import { render } from "./LayoutContainer.vue?vue&type=template&id=4ad4256e"
import script from "./LayoutContainer.vue?vue&type=script&lang=ts"
export * from "./LayoutContainer.vue?vue&type=script&lang=ts"
script.render = render

export default script